import { ExamineeEditInternalComponent } from "../app/internal/common/components/edit-examinee/examinee.edit.component";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { BrowserModule } from "@angular/platform-browser";
import { DataTableModule } from "angular2-datatable";
import { BsDatepickerModule, ModalModule, PopoverModule } from "ngx-bootstrap";

import { AccommSupportReviewComponent } from "../app/internal/accmgr/accomms-support-review/accomms-support-review.component";
import { AssignedComponent } from "../app/internal/accmgr/assigned/assigned.component";
import { IncompleteComponent } from "../app/internal/accmgr/incomplete/incomplete.component";
import { DeletedComponent } from "../app/internal/accmgr/deleted/deleted.component";
import { AutoApprovedComponent } from "../app/internal/accmgr/auto-approved/auto-approved.component";
import { AccommodationCategoryComponent } from "../app/internal/accmgr/ba/accommodation-category/accommodationcat.component";
import { AccommodationComponent } from "../app/internal/accmgr/ba/Accommodation/accommodation.component";
import { AnalystsComponent } from "../app/internal/accmgr/ba/analysts/analysts.component";
import { DisabilityCategoryComponent } from "../app/internal/accmgr/ba/disability-category/disabilitycat.component";
import { DisabilityComponent } from "../app/internal/accmgr/ba/Disability/disability.component";
import { DocTypeComponent } from "../app/internal/accmgr/ba/document-type/documenttype.component";
import { DynamicContentComponent } from "../app/internal/accmgr/ba/dynamic-content/dynamiccontent.component";
import { BAComponent } from "../app/internal/accmgr/ba/Home/ba.component";
import { InternalPlanComponent } from "../app/internal/accmgr/ba/internal-plan/internalplan.component";
import { InternalTestComponent } from "../app/internal/accmgr/ba/internal-test/internaltest.component";
import { NavMenuComponent } from "../app/internal/accmgr/ba/nav-menu/nav-menu.component";
import { ParagraphsComponent } from "../app/internal/accmgr/ba/Paragraphs/paragraphs.component";
import { SpecialAuthCodesComponent } from "../app/internal/accmgr/ba/special-authorization-codes/specialauthcodes.component";
import { TestAdministrationsComponent } from "../app/internal/accmgr/ba/test-administrations/testadministrations.component";
import { CompletedComponent } from "../app/internal/accmgr/completed/completed.component";
import { ConsultantDecisionComponent } from "../app/internal/accmgr/consultant-decision/consultant-decision.component";
import { ConsultantReviewSubmitComponent } from "../app/internal/accmgr/consultant-review-submit/consultant-reviewsubmit.component";
import { CustomExamineeRequestDetailsComponent } from "../app/internal/accmgr/custom-examinee-review-details/custom-examinee-review-details.component";
import { ExamineeRequestDetailsComponent } from "../app/internal/accmgr/examinee-request-details/examinee-request-details.component";
import { LandingComponent } from "../app/internal/accmgr/landing/landing.component";
import { MyRequestComponent } from "../app/internal/accmgr/my-request/my-request.component";
import { AccommodationService } from "../app/internal/accmgr/services/accommodation.service";
import { AccommodationCatService } from "../app/internal/accmgr/services/accommodationcat.service";
import { AccommSupportReviewService } from "../app/internal/accmgr/services/accommsupportreview.service";
import { ConsultantDecisionService } from "../app/internal/accmgr/services/consultant-decision.service";
import { ConsultantsService } from "../app/internal/accmgr/services/consultants.service";
import { DisabilityService } from "../app/internal/accmgr/services/disability.service";
import { DisabilityCatService } from "../app/internal/accmgr/services/disabilitycat.service";
import { DocTypeService } from "../app/internal/accmgr/services/docType.service";
import { DynamicContentService } from "../app/internal/accmgr/services/dynamiccontent.service";
import { InternalLoggerService } from "../app/internal/accmgr/services/internal-audit-logger.service";
import { InternalPlanService } from "../app/internal/accmgr/services/internalplan.service";
import { InternalTestService } from "../app/internal/accmgr/services/internaltest.service";
import { ParagraphsService } from "../app/internal/accmgr/services/paragraphs.service";
import { PersonRequestService } from "../app/internal/accmgr/services/person-request-service";
import { SpecialAuthCodesService } from "../app/internal/accmgr/services/specialauthcodes.service";
import { TestAdministrationsService } from "../app/internal/accmgr/services/testadministrations.service";
import { AccsupportAccommodationsComponent } from "../app/internal/accomsupport/accsupportaccomodations/accsupportaccomodations.component";
import { AccSupportDocumentationComponent } from "../app/internal/accomsupport/accsupportdocumentation/accsupportdocumentation.component";
import { AccSupportLandingComponent } from "../app/internal/accomsupport/accsupportlanding/accsupportlanding.component";
import { AccSupportPlanComponent } from "../app/internal/accomsupport/accsupportplan/accsupportplan.component";
import { AccSupportReasonsComponent } from "../app/internal/accomsupport/accsupportreasons/accsupportreasons.component";
import { AssignTestAdminComponent } from "../app/internal/accomsupport/assign-test-administration/assign-test-administration.component";
import { ReqConfirmationComponent } from "../app/internal/accomsupport/confirmation/reqconfirmation.component";
import { ExamineeInternalComponent } from "../app/internal/accomsupport/edit-examinee/examinee.component";
import { ExamineeInternalForm } from "../app/internal/accomsupport/edit-examinee/examinee.form";
import { ExamineeAccRequestDetailsComponent } from "../app/internal/accomsupport/examinee-request-details/examinee-request-details.component";
import { PaperReqSubmitComponent } from "../app/internal/accomsupport/paperreqsubmit/paperreqsubmit.component";
import { PaperReqTestInfoComponent } from "../app/internal/accomsupport/paperreqtestinfo/paperreqtestinfo.component";
import { PaperRequestLandingComponent } from "../app/internal/accomsupport/paperrequestlanding/paperrequestlanding.component";
import { PaperExamineeRequestService } from "../app/internal/accomsupport/process-paper-request/examinee/paper-examinee-request.service";
import { PaperExamineeComponent } from "../app/internal/accomsupport/process-paper-request/examinee/paper-examinee.component";
import { PaperExamineeForm } from "../app/internal/accomsupport/process-paper-request/examinee/paper-examinee.form";
import { PaperStepperComponent } from "../app/internal/accomsupport/process-paper-request/stepper/paper-stepper.component";
import { AccSupportPlanService } from "../app/internal/accomsupport/service/accsupportplan.service";
import { AssignTestService } from "../app/internal/accomsupport/service/assign-test.service";
import { ExamineeInternalRequestService } from "../app/internal/accomsupport/service/examinee-request.service";
import { PaperReqSubmitService } from "../app/internal/accomsupport/service/paperreqsubmit.service";
import { PaperReqTestInfoService } from "../app/internal/accomsupport/service/paperreqtestinfo.service";
import { PaperRequestService } from "../app/internal/accomsupport/service/paperrequest.service";
import { TranferStudentService } from "../app/internal/accomsupport/service/transfer-student.service";
import { UnAssignTestAdminComponent } from "../app/internal/accomsupport/unassign-test-administration/unassign-test-administration.component";
import { AssignTestAdminCommonComponent } from "../app/internal/common/components/assign-test-administration/assign-test-administration.common.component";
import { SearchComponent } from "../app/internal/common/search/search.component";
import { DownloadDocumentService } from "../app/internal/common/services/downloaddocument.service";
import { InternalSendEmailService } from "../app/internal/common/services/internalsendemail.service";
import { ConsultantLandingComponent } from "../app/internal/internalconsultants/consultantlanding/consultantlanding.component";
import { AccomSupportService } from "./../app/internal/common/services/accomsupport.service";
import { AppComponent } from "./app.component";
import { InterceptorModule } from "./app.interceptor";
import { AppRoutesModule } from "./app.route";
import { OrganizationConstants } from "./constants/organization-constants";
import { TAAConstants } from "./constants/taa-constants";
import { ContactusComponent } from "./contactus/contactus.component";
import { ExamineesService } from "./examinees/examinees.service";
import { ListComponent } from "./examinees/list/list.component";
import { FaqComponent } from "./faq/faq.component";
import { OrganizationComponent } from "./organization/organization/organization.component";
import { RequestHistoryComponent } from "./request-history/request-history.component";
import { AccommodationsComponent } from "./request/accommodations/accommodations.component";
import { ConfirmationComponent } from "./request/confirmation/confirmation.component";
import { DocumentationComponent } from "./request/documentation/documentation.component";
import { ExamineeRequestService } from "./request/examinee/examinee-request.service";
import { ExamineeComponent } from "./request/examinee/examinee.component";
import { ExamineeForm } from "./request/examinee/examinee.form";
import { PlanComponent } from "./request/plan/plan.component";
import { ReasonComponent } from "./request/reason/reason.component";
import { RequestSubmitComponent } from "./request/requestsubmit/requestsubmit.component";
import { StepperComponent } from "./request/stepper/stepper.component";
import { TestinginformationComponent } from "./request/testinginformation/testinginformation.component";
import { AccommsService } from "./services/accomms.service";
import { AppService } from "./services/app.service";
import { LoggerService } from "./services/audit-logger.service";
import { AuthExternalB2BGuard } from "./services/auth-external-b2b.guard";
import { AuthInternalAccmgrGuard } from "./services/auth-internal-accmgr-guard";
import { AuthInternalAccommodationSupportGuard } from "./services/auth-internal-accommodation-support-guard";
import { AuthInternalConsultantGuard } from "./services/auth-internal-consultant-guard";
import { AuthInternalGuard } from "./services/auth-internal-guard";
import { CommonService } from "./services/common.service";
import { DocumentService } from "./services/document.service";
import { ExportToCSVService } from "./services/exporttocsv.service";
import { HeaderService } from "./services/header.service";
import { LandingService } from "./services/landing.service";
import { OrganizationserviceService } from "./services/organizationservice.service";
import { PersonService } from "./services/person.service";
import { PlanService } from "./services/plan.service";
import { ReasonService } from "./services/reason.service";
import { RequestHistoryService } from "./services/requesthistory.service";
import { RequestSubmitService } from "./services/requestsubmit.service";
import { SendEmailService } from "./services/sendemail.service";
import { SessionTimeoutService } from "./services/session-timeout.service";
import { TestService } from "./services/test.service";
import { FooterComponent } from "./shared/footer/footer.component";
import { HeaderComponent } from "./shared/header/header.component";
import { SystemErrorComponent } from "./system-error/system-error.component";
import { TransferStudentCommonComponent } from "../app/internal/common/components/transferstudent/transferstudent.component";
import { UnAssignTestAdminCommonComponent } from "../app/internal/common/components/unassign-test-administration/unassign-test-administration.component";
import { ExamineeEditForm } from "../app/internal/common/components/edit-examinee/examinee.edit.form";
import { MatSelectModule } from "@angular/material/select";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  declarations: [
    AppComponent,
    ListComponent,
    ContactusComponent,
    FaqComponent,
    PlanComponent,
    ReasonComponent,
    AccSupportReasonsComponent,
    AccSupportDocumentationComponent,
    AccSupportPlanComponent,
    DocumentationComponent,
    HeaderComponent,
    FooterComponent,
    ExamineeComponent,
    ExamineeInternalComponent,
    TestinginformationComponent,
    AccommodationsComponent,
    AccommSupportReviewComponent,
    RequestHistoryComponent,
    ConfirmationComponent,
    OrganizationComponent,
    SystemErrorComponent,
    LandingComponent,
    ConsultantLandingComponent,
    NavMenuComponent,
    BAComponent,
    DocTypeComponent,
    SearchComponent,
    InternalPlanComponent,
    AnalystsComponent,
    ExamineeRequestDetailsComponent,
    ExamineeAccRequestDetailsComponent,
    SpecialAuthCodesComponent,
    ParagraphsComponent,
    InternalTestComponent,
    TestAdministrationsComponent,
    DisabilityCategoryComponent,
    DynamicContentComponent,
    DisabilityComponent,
    AccommodationCategoryComponent,
    AccommodationComponent,
    StepperComponent,
    RequestSubmitComponent,
    ConsultantDecisionComponent,
    ConsultantReviewSubmitComponent,
    MyRequestComponent,
    AutoApprovedComponent,
    CompletedComponent,
    AssignedComponent,
    IncompleteComponent,
    DeletedComponent,
    AccSupportLandingComponent,
    AssignTestAdminComponent,
    UnAssignTestAdminComponent,
    PaperRequestLandingComponent,
    PaperReqTestInfoComponent,
    CustomExamineeRequestDetailsComponent,
    PaperExamineeComponent,
    PaperReqSubmitComponent,
    PaperStepperComponent,
    AccsupportAccommodationsComponent,
    ReqConfirmationComponent,
    AssignTestAdminCommonComponent,
    ExamineeEditInternalComponent,
    TransferStudentCommonComponent,
    UnAssignTestAdminCommonComponent
  ],
  imports: [
    BrowserModule,
    AppRoutesModule,
    InterceptorModule,
    BsDatepickerModule.forRoot(),
    PopoverModule.forRoot(),
    DataTableModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    ReactiveFormsModule,
    ModalModule.forRoot(),
    MatSelectModule,
    BrowserAnimationsModule
  ],
  providers: [
    OrganizationserviceService,
    RequestHistoryService,
    PlanService,
    AppService,
    HeaderService,
    OrganizationConstants,
    TAAConstants,
    ReasonService,
    AccommsService,
    TestService,
    StepperComponent,
    ExamineesService,
    ExamineeRequestService,
    ExportToCSVService,
    ExamineeInternalRequestService,
    PaperRequestService,
    ExamineeInternalForm,
    CommonService,
    ExamineeForm,
    PersonService,
    DocumentService,
    RequestSubmitService,
    LoggerService,
    SendEmailService,
    SessionTimeoutService,
    LandingService,
    DownloadDocumentService,
    AuthExternalB2BGuard,
    AuthInternalAccmgrGuard,
    AuthInternalAccommodationSupportGuard,
    AuthInternalConsultantGuard,
    AuthInternalGuard,
    InternalPlanService,
    AccommodationService,
    InternalSendEmailService,
    AccommSupportReviewService,
    AccommodationCatService,
    ConsultantsService,
    DocTypeService,
    DisabilityService,
    DisabilityCatService,
    TestAdministrationsService,
    SpecialAuthCodesService,
    ParagraphsService,
    InternalTestService,
    DynamicContentService,
    ConsultantDecisionService,
    PersonRequestService,
    InternalLoggerService,
    AssignTestService,
    AccomSupportService,
    PaperReqTestInfoService,
    AccSupportPlanService,
    TranferStudentService,
    PaperExamineeRequestService,
    PaperReqSubmitService,
    PaperExamineeForm,
    ExamineeEditForm
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./client/views/app.module.ts